import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Spin } from "antd";
import { useState } from "react";

export function PrimaryButton({
  loading,
  icon,
  activeIcon,
  iconPosition = "start",
  onClick,
  children,
  className,
  disabled,
  ...rest
}) {
  const [isHovering, setIsHovering] = useState(false);

  return icon ? (
    <Button
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      loading={loading}
      icon={
        isHovering && activeIcon ? (
          <img src={activeIcon} alt="button" />
        ) : (
          <img src={icon} alt="button" />
        )
      }
      disabled={disabled}
      iconPosition={iconPosition}
      className={`${
        !disabled
          ? "hover:!border-primary-tint hover:!text-primary-tint hover:!bg-secondary-main hover:!border ":""
      } font-medium px-4 w-fit h-8 flex !rounded-lg text-sm text-secondary-main !leading-none bg-primary-tint  ${className}`}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Button>
  ) : (
    <Button
      loading={loading}
      className={`${
        !disabled
          ? "hover:!border-primary-tint hover:!text-primary-tint hover:!bg-secondary-main hover:!border ":""
      } font-medium px-4 w-fit h-8 flex !rounded-lg text-sm text-secondary-main !leading-none bg-primary-tint  ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Button>
  );
}

export function SecondaryButton({
  loading,
  icon,
  activeIcon,
  iconPosition = "start",
  onClick,
  children,
  className,
  disabled,
  ...rest
}) {
  const [isHovering, setIsHovering] = useState(false);
  return icon ? (
    <Button
      loading={loading}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      icon={
        isHovering && activeIcon ? (
          <img src={activeIcon} alt="button" />
        ) : (
          <img src={icon} alt="button" />
        )
      }
      disabled={disabled}
      iconPosition={iconPosition}
      className={`font-medium ${
        !disabled
          ? "hover:!border-secondary-main hover:!border hover:!text-secondary-main hover:!bg-primary-tint ":""
      } px-4 w-fit h-8 !rounded-lg text-sm border-primary-tint text-primary-tint  bg-secondary-main !leading-none  ${className}`}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Button>
  ) : (
    <Button
      loading={loading}
      className={`font-medium ${
        !disabled
          ? "hover:!border-secondary-main hover:!border hover:!text-secondary-main hover:!bg-primary-tint ":""
      } px-4 w-fit h-8 !rounded-lg text-sm border-primary-tint text-primary-tint  bg-secondary-main !leading-none  ${className}`}
      onClick={onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Button>
  );
}

export function IconButton({
  icon,
  activeIcon,
  label,
  className,
  onClick,
  iconClassName,
  disabled,
  loading,
}) {
  const [isHovering, setIsHovering] = useState(false);
  return (
    <button
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
      className={className}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {loading ? (
        <Spin spinning indicator={<Loading3QuartersOutlined spin className="!text-primary-tint"/>} size="small" />
      ) : isHovering && activeIcon ? (
        <img src={activeIcon} alt={label} className={iconClassName} />
      ) : (
        <img src={icon} alt={label} className={iconClassName} />
      )}
      {label}
    </button>
  );
}
